import { CHAT_TYPE } from '@/services/chat/channels';
import customerAvatar from '@/assets/images/customer_profile_photo.jpg';
import driverAvatar from '@/assets/images/driver_profile_photo.jpg';

const VISUALS = {
	[CHAT_TYPE.CUSTOMER]: { icon: 'person', accent: 'var(--primary)', tint: '#ffd1dc', face: customerAvatar },
	[CHAT_TYPE.SUPPORT]: { icon: 'support', accent: 'var(--success)', tint: '#cdf4d8' },
	[CHAT_TYPE.DRIVER]: { icon: 'courier', accent: 'var(--info)', tint: '#cde1fe', face: driverAvatar },
};

export const chatChannelVisual = (typeId) => VISUALS[typeId] || VISUALS[CHAT_TYPE.SUPPORT];
